import React, { useState } from "react"
import API from "../../api/axios"
import { Button, Form, FormGroup, Label, Input } from "reactstrap"
import { toast } from "react-toastify"

const DurationForm = ({ refresh }) => {
  const [value, setValue] = useState("")
  const [error, setError] = useState("")

  const handleSubmit = async e => {
    e.preventDefault()

    if (!value || isNaN(value)) {
      setError("Please enter a valid numeric value.")
      return
    }

    const authToken = localStorage.getItem("authToken")

    try {
      await API.post(
        "/duration",
        { value: Number(value) },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        },
      )

      if (refresh) refresh()
      toast.success("Duration added successfully!", { autoClose: 2000 })
      setValue("")
      setError("")
    } catch (err) {
      console.error("Error adding duration:", err.response?.data || err.message)
      setError(
        err.response?.data?.message ||
          "Failed to add duration. Please try again.",
      )
    }
  }

  return (
    <Form inline onSubmit={handleSubmit} className="mb-3">
      <FormGroup className="mr-2">
        <Label for="durationValue" className="mr-2">
          Duration (minutes)
        </Label>
        <Input
          type="number"
          id="durationValue"
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Enter value"
          min="1"
          required
        />
      </FormGroup>
      <Button color="primary" type="submit">
        Add Duration
      </Button>
      {error && <p className="text-danger mt-2">{error}</p>}
    </Form>
  )
}

export default DurationForm
